<div id="chartBondAndStocksPortfolio" [style.width]="width" [style.height]="height"></div>
<!-- <div id="chartBondAndStocksPortfolio" [gSstyle]="{'width: 'width}"+'; height: '+{{height}}"></div> -->
